export default "__VITE_ASSET__DbhdKQxb__"